'use strict';

module.exports = {
    STATE_UPDATE: 'backlog.state.update',
    EMPTY: 'backlog.empty'
};